
const TermsConditions = () => (
  <div style={{ padding: '2rem', lineHeight: 1.6 }}>
    <h1>利用規約</h1>
    <p>最終更新日：2026年11月4日</p>

    <p>
      本利用規約（以下「本規約」といいます。）は、
      CDI CO., LTD.（以下「当社」といいます。）が提供する
      FITEASY向け機器管理システム「ランチャー」
      （以下「本システム」といいます。）の利用条件を定めるものです。
    </p>
    <p>
      本システムをご利用いただく場合は、
      本規約をご確認のうえ、同意いただく必要があります。
    </p>

    <h2>第1条（目的）</h2>
    <p>
      本システムは、FITEASYに関連する機器の登録情報、
      接続状態、稼働状況などを管理・確認し、
      機器の運用および保守業務を支援することを目的としています。
    </p>

    <h2>第2条（利用対象）</h2>
    <p>
      本システムは、当社または関係する管理者により
      利用を許可されたユーザーを対象とします。
    </p>
    <p>
      利用者は、許可された権限の範囲内で
      本システムを使用するものとします。
    </p>

    <h2>第3条（提供機能）</h2>
    <p>本システムでは、主に以下の機能を提供します。</p>
    <ol>
      <li>登録機器の情報および認証状態の確認</li>
      <li>機器のグループ情報の確認および管理</li>
      <li>機器の接続状態およびプログラム稼働状況の監視</li>
      <li>機器に関するアラート情報の確認</li>
      <li>機器のバックアップ情報の確認および取得</li>
      <li>その他、機器の運用・保守に関連する機能</li>
    </ol>
    <p>
      利用可能な機能は、ユーザーの権限や
      システムの設定によって異なる場合があります。
    </p>

    <h2>第4条（アカウント管理）</h2>
    <p>
      利用者は、ログインに使用するアカウント情報および
      パスワードを適切に管理するものとします。
    </p>
    <p>
      アカウント情報の第三者への貸与、共有、
      不正使用を禁止します。
    </p>
    <p>
      不正アクセスやアカウントの不正利用が疑われる場合は、
      速やかにシステム管理者へ連絡してください。
    </p>

    <h2>第5条（禁止事項）</h2>
    <p>利用者は、以下の行為を行ってはなりません。</p>
    <ol>
      <li>許可されていない機器や情報へのアクセス</li>
      <li>他の利用者のアカウントの不正使用</li>
      <li>本システムの正常な動作を妨害する行為</li>
      <li>システム上の情報を不正に取得、変更または削除する行為</li>
      <li>本システムを本来の業務目的以外に不正利用する行為</li>
      <li>その他、法令または本規約に違反する行為</li>
    </ol>

    <h2>第6条（機器情報の取扱い）</h2>
    <p>
      本システムに表示される機器情報、稼働状況、
      監視データおよびバックアップ情報は、
      適切な機器管理と保守業務のために利用するものとします。
    </p>
    <p>
      利用者は、業務上必要な範囲を超えて、
      これらの情報を第三者へ開示または提供してはなりません。
    </p>

    <h2>第7条（システムの停止・変更）</h2>
    <p>
      当社は、保守作業、障害対応、セキュリティ対策など、
      システム運用上必要な場合に、
      本システムの全部または一部を一時的に停止・変更することがあります。
    </p>
    <p>
      計画的な停止については、可能な範囲で事前に案内します。
    </p>

    <h2>第8条（表示情報について）</h2>
    <p>
      本システムに表示される機器の接続状態や稼働状況などは、
      通信環境、機器の状態、情報更新のタイミングによって、
      実際の状態と差異が生じる場合があります。
    </p>
    <p>
      重要な保守・運用上の判断を行う場合は、
      必要に応じて対象機器の状況を確認してください。
    </p>

    <h2>第9条（個人情報の取扱い）</h2>
    <p>
      本システムに関連して取り扱う個人情報については、
      別途定めるプライバシーポリシーに従い、
      適切に取り扱います。
    </p>

    <h2>第10条（利用規約の変更）</h2>
    <p>
      当社は、法令の変更、サービス内容の変更、
      運用上の必要性などに応じて、本規約を変更することがあります。
    </p>
    <p>
      変更する場合は、変更内容および適用時期を、
      本システム上での掲示その他適切な方法により周知します。
    </p>

    <h2>第11条（お問い合わせ）</h2>
    <p>
      本システムの利用方法、アカウント管理、障害その他の
      運用に関するお問い合わせは、
      本システムの運用担当者までご連絡ください。
    </p>

    <p style={{ marginTop: '2rem' }}>
      CDI CO., LTD.
    </p>
  </div>
);

export default TermsConditions;
